import chevronLeft from "@assets/images/chevron-left.svg";
import { Portal, Typography } from "@material-ui/core";
import AppHeaderContext from "@saleor/components/AppLayout/AppHeaderContext";
import Skeleton from "@saleor/components/Skeleton";
import { makeStyles } from "@saleor/macaw-ui";
import React from "react";

export interface AppHeaderProps {
  children: React.ReactNode;

  onBack();
}

const useStyles = makeStyles(
  theme => ({
    backArrow: {},
    menuButton: {
      flex: "0 0 auto",
      marginLeft: -theme.spacing(2),
      marginRight: theme.spacing(),
      marginTop: -theme.spacing(2)
    },
    root: {
      border: "none",
      padding: "0px",
      background: "none",
      outline: "inherit",
      "&:hover": {
        color: theme.typography.body1.color
      },
      alignItems: "center",
      color: theme.palette.grey[500],
      cursor: "pointer",
      display: "flex",
      marginTop: theme.spacing(0.5),
      transition: theme.transitions.duration.standard + "ms",
      [theme.breakpoints.down("sm")]: {
        margin: theme.spacing(4, 0, 0, 0)
      }
    },
    skeleton: {
      marginBottom: theme.spacing(2),
      width: "10rem"
    },
    title: {
      color: "#222222",
      flex: 1,
      marginLeft: theme.spacing(),
      textTransform: "uppercase",
      fontSize: 14
    }
  }),
  { name: "AppHeader" }
);

const AppHeader: React.FC<AppHeaderProps> = props => {
  const { children, onBack } = props;

  const classes = useStyles(props);

  return (
    <AppHeaderContext.Consumer>
      {anchor =>
        anchor ? (
          <Portal container={anchor.current}>
            <button
              className={classes.root}
              onClick={onBack}
              data-testid="app-header-back-button"
              id="app-header-back-button"
            >
              <img
                src={chevronLeft}
                className={classes.backArrow}
                alt="Back button"
              />
              {children ? (
                <Typography className={classes.title}>{children}</Typography>
              ) : (
                <Skeleton className={classes.skeleton} />
              )}
            </button>
          </Portal>
        ) : null
      }
    </AppHeaderContext.Consumer>
  );
};
AppHeader.displayName = "AppHeader";
export default AppHeader;
